export default {
  isUserAuthorized: null,
  authToken: null,
  userData: null,
  sitesList: [],
  partnersList: [],
  subSourcesList: [],
  marketsList: [],
  devicesList: [],
  scrollOffsetY: 0,
  URLparams: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/base/state.js